// extracted by mini-css-extract-plugin
export var box = "_5h-0";
export var check = "_5h-1";
export var checkboxButton = "_5h-6";
export var checkboxGroup = "_5h-5";
export var disabled = "_5h-7";
export var ghost = "_5h-9";
export var input = "_5h-2";
export var label = "_5h-4";
export var normal = "_5h-8";
export var uncheck = "_5h-3";